module.exports = __webpack_public_path__ + "images/index/img04.6bd707c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/dalcc/img04.jpg
// module id = 3f+p
// module chunks = 21